import React from 'react';
import PropTypes from 'prop-types';
import { SubmissionSteps } from '../helpers/submissionConfig';

import ChevronDown from '@images/svg/ui/chevron-down.svg';
import ChevronUp from '@images/svg/ui/chevron-up.svg';

const FormProgress = ({ index, canGoBack, handleGoBack, canGoNext, handleGoNext }) => {
  return (
    <div className='c-form-progress'>
      <div className='c-form-progress__indicator'>
        <div className='c-form-progress__indicator-label'>
          {`Schritt ${index + 1} von ${SubmissionSteps.length}`}
        </div>
        <div
          className='c-form-progress__indicator-bar'
          style={{ '--progress': (index + 1) / SubmissionSteps.length }}
        />
      </div>
      <div className='c-form-progress__arrows'>
        <button
          title='Zurück'
          className='c-form-progress__arrow'
          disabled={!canGoBack}
          onClick={handleGoBack}
        >
          <ChevronUp />
        </button>
        <button
          title='Weiter'
          className='c-form-progress__arrow'
          disabled={!canGoNext}
          onClick={handleGoNext}
        >
          <ChevronDown />
        </button>
      </div>
    </div>
  );
};

FormProgress.propTypes = {
  canGoBack: PropTypes.bool,
  canGoNext: PropTypes.bool,
  handleGoBack: PropTypes.func.isRequired,
  handleGoNext: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default FormProgress;
